import { Box } from '@mui/material'
import { ColDef } from 'ag-grid-community'
import { getQuestionnaireReport } from 'api/reports'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import TableToolbar from 'components/table/TableToolbar'
import {
  createCohortsNamesColumn,
  createCohortsNamesCsvColumn,
  useCohortsFilter,
} from 'features/Cohorts'
import { useExportCSV } from 'hooks/useExportCSV'
import { useGridControl } from 'hooks/useGridControl'
import React, { useCallback } from 'react'
import { BaseTableRequest, FilterModel } from 'types'
import { useGetDataSource } from 'utils'

const columnDefs: ColDef[] = [
  { headerName: 'Exam name', field: 'questionnaireName', flex: 1 },
  createCohortsNamesColumn('cohortNames'),
  {
    headerName: 'Number of Completed Exams',
    field: 'completedCount',
    flex: 1,
  },
  { headerName: 'Passed Exams', field: 'passedCount', flex: 1 },
  { headerName: 'Failed Exams', field: 'failedCount', flex: 1 },
  {
    headerName: '% of Passed Exams',
    field: 'passedPercent',
    flex: 1,
  },
  {
    headerName: '% of Failed Exams',
    field: 'failedPercent',
    flex: 1,
  },
]

export const ReportsQuestionnaires = () => {
  const { cohortsFilterValue, CohortsFilter } = useCohortsFilter()

  const getRequest = useCallback(
    (req: BaseTableRequest) => {
      const filter: FilterModel = {
        ...(req.filter || {}),
      }

      if (cohortsFilterValue) {
        filter.cohortId = cohortsFilterValue
      }

      const request = { ...req, filter }

      return getQuestionnaireReport(request)
    },
    [cohortsFilterValue],
  )

  const getDataSource = useGetDataSource(getRequest)
  const { onGridReady, gridApi, columnApi } = useGridControl(getDataSource)

  const { csvLoading, onExportCSV } = useExportCSV(
    getRequest,
    gridApi,
    columnApi,
    columnDefs.map((col) => {
      if (col.field === 'cohortNames') {
        return createCohortsNamesCsvColumn('cohortNames')
      }
      return { label: col.headerName || '', value: col.field || '' }
    }),
    'Exams Report.csv',
  )

  return (
    <>
      <TableToolbar
        left={<Box minWidth="200px">{CohortsFilter}</Box>}
        exportCSVEnable
        onExportCSV={onExportCSV}
        csvLoading={csvLoading}
      />
      <InfinityAgGrid pagination columnDefs={columnDefs} onGridReady={onGridReady} />
    </>
  )
}
